import React from "react";
import { sidebarMobileItems } from "../../utils/sideBarItems";
import { Link } from "react-router-dom";
const SidebarMobile = () => {
  return (
    <div className="w-[100%] md:w-[60%] mx-auto flex items-center justify-between  px-[8px]">
      {sidebarMobileItems?.map((item, index) => (
        <Link to={item.url}>
          <div
            key={index}
            className="mt-[4px] flex flex-col items-center justify-center text-center p-[8px] cursor-pointer"
          >
            <img className="text-center" src={item.icon} alt="" />
            <p
              className={`text-[12px] pt-[4px] text-center ${
                item.active ? "text-[#34BD5A]" : "text-white"
              }`}
            >
              {item.name}
            </p>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default SidebarMobile;
